import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static targets = ['input', 'message']

    declare readonly inputTarget: HTMLInputElement
    declare readonly hasInputTarget: boolean
    declare readonly messageTarget: HTMLElement
    declare readonly hasMessageTarget: boolean

    connect() {
        this.element.addEventListener('checkbox:add-error', this.onAddError as EventListener)
        this.element.addEventListener('checkbox:clear-error', this.onClearError as EventListener)

        const input = this.resolveInput()

        if (input) {
            input.addEventListener('change', this.onInputChange)
        }
    }

    disconnect() {
        this.element.removeEventListener('checkbox:add-error', this.onAddError as EventListener)
        this.element.removeEventListener('checkbox:clear-error', this.onClearError as EventListener)

        const input = this.resolveInput()

        if (input) {
            input.removeEventListener('change', this.onInputChange as EventListener)
        }
    }

    clearError(): void {
        this.resolveCheckboxElement()?.classList.remove('error')

        if (this.hasMessageTarget) {
            this.messageTarget.textContent = ''
        }
    }

    setError(message: string): void {
        this.resolveCheckboxElement()?.classList.add('error')

        if (this.hasMessageTarget) {
            this.messageTarget.textContent = message
        }
    }

    private onAddError = (event: CustomEvent) => {
        const message = (event.detail && (event.detail.message as string)) || ''

        if (!message) {
            return
        }

        this.setError(message)
    }

    private onInputChange = () => {
        this.clearError()
    }

    private onClearError = () => {
        this.clearError()
    }

    private resolveInput(): HTMLInputElement | null {
        if (this.hasInputTarget) {
            return this.inputTarget
        }

        return this.element.querySelector('.checkbox input[type="checkbox"]') as HTMLInputElement | null
    }

    private resolveCheckboxElement(): HTMLElement | null {
        return this.element.querySelector('.checkbox') as HTMLElement | null
    }
}
